
const loadCaptchaBasic = () => import('captcha_basic').then(module => module.default);
export const basic_captcha = loadCaptchaBasic
const loadCaptchaGoogleV2 = () => import('captcha_google_v2').then(module => module.default);
export const google_v2_captcha = loadCaptchaGoogleV2
const loadEditorChart = () => import('editor-chart').then(module => module.default);
export const chart_editor = loadEditorChart
const loadEditorFormula = () => import('editor-formula').then(module => module.default);
export const formula_editor = loadEditorFormula
const loadEditorStacks = () => import('editor-stacks').then(module => module.default);
export const editor_stacks = loadEditorStacks
const loadEmbedBasic = () => import('embed-basic').then(module => module.default);
export const basic_embed = loadEmbedBasic
const loadQuickLinks = () => import('quick-links').then(module => module.default);
export const quick_links = loadQuickLinks
const loadRenderMarkdownCodehighlight = () => import('render-markdown-codehighlight').then(module => module.default);
export const render_markdown_codehighlight = loadRenderMarkdownCodehighlight